
  import Vue from 'vue'
  import ConnectorService from '@/services/ConnectorService';
import { extractErrorMessage } from '@/utils/Util';

  export default Vue.extend({
    name: 'ConnectorDeleteDialog',
    props: ['connector'],
    data: () => ({
        localDialog: false,
        alertText: "",
        alertVisible: false,
        alertType: "error",
        loading: false,
    }),
    methods: {
      close() {
        this.localDialog = false;
      },
      clear() {
        this.alertVisible = false;
        this.loading = false;
      },
      dismiss() {
        this.clear();
        this.close();
      },
      confirmDelete() {
        this.loading = true;
      
        ConnectorService.deleteConnector(this.$root.$store.state.session.selectedTenant.uuid, this.connector.uuid).then(() => {
            this.alertType = "success";
            this.alertText = this.$t('connector.successDelete') as string;
            this.alertVisible = true;
            this.loading = false;

            setTimeout(() => { 
                this.$emit("delete", this.connector);
                this.dismiss(); 
            }, 2000);
        }).catch((err) => {
            console.log(err);
            console.log(err.response);
            this.alertType = "error";
            this.alertText = this.$t('connector.errorDelete') + ' ' + extractErrorMessage(err);
            this.alertVisible = true; 
            this.loading = false;
        });
      }
    }
  })
